import {
    getBillingCodeIdLoading,
    getBillingCodeIdRequest,
    getBillingCodeIdSuccess,
    getBillingCodeIdReject,
} from "../../actions/billingCode/getId";

export const getBillingCodeId = (formData) => async (dispatch, getState) => {
    dispatch(getBillingCodeIdLoading());
    try {
        const { data } = await getBillingCodeIdRequest(formData, getState);
        dispatch(getBillingCodeIdSuccess(data))
    } catch (error) {
        dispatch(getBillingCodeIdReject(error))
    }
    return Promise.resolve();
};
